module.exports = __webpack_public_path__ + "media/components/country-flag/static/km-08bc8d346fd8368e3d47ba3bb8acfe3c.svg";